import { useAppDispatch, useAppSelector } from "../store/hooks";
import { syncClientData } from "../actions/client";
import { Client } from "../interfaces/ClientInterface";

interface SyncClientProps<T> {
  clientId: number;
  toUpdateKey: string;
  toUpdateValue: T;
}

const useSyncClient = (): {
  syncClient: <T>({ clientId, toUpdateKey, toUpdateValue }: SyncClientProps<T>) => void;
} => {
  const dispatch = useAppDispatch();
  const collection = useAppSelector((state) => state.clients.collection);

  const syncClient = <T>({ clientId, toUpdateKey, toUpdateValue }: SyncClientProps<T>) => {
    const client = collection.find((c: Client) => c.id === clientId);
    if (!client) return;

    dispatch(
      syncClientData({
        ...client,
        [toUpdateKey]: toUpdateValue
      })
    );
  };

  return { syncClient };
};

export default useSyncClient;
